module.exports = __webpack_public_path__ + "img/sceneIcon1-1.09e9d225.png";